import { backendApi } from "../dynamicBAseQuery";

export const ViewCandidatePaymentsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        CandidateReferralCommissionDetails: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: "getAllCandidateReferralCommissionDetails",
                body: { ...args }
            })
        }),
        referralCommissionApproval: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "referralCommissionApproval",
                body: { ...args }
            })
        }),
        updatePaymentStatus: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "updatePaymentStatus",
                params: args
            })
        }),
        refundReturnById: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "refundReturnById",
                body: { ...args }
            })
        }),
        refundReturnAmountUpdate: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "refundReturnAmountUpdate",
                params: args
            })
        }),

        commissionApprove: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "referralCommissionApproval",
                body: { ...args }
            })
        }),

        referralCommissionRejectedAndHold: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: "referralCommissionRejectedAndHold",
                body: { ...args }
            })
        }),


    })
})

export const {
    useCandidateReferralCommissionDetailsMutation,
    useReferralCommissionApprovalMutation,
    useUpdatePaymentStatusMutation,
    useRefundReturnByIdMutation,
    useRefundReturnAmountUpdateMutation,
    useCommissionApproveMutation,
    useReferralCommissionRejectedAndHoldMutation,
} = ViewCandidatePaymentsApi